export const configObjectAllPoUsersWBTV = {
  iscolumnFilterRequired: true,
  headings: [
    {
      headingLabel: "PO#",
      icon: "",
      width: "7%",
    },
    {
      headingLabel: "Date",
      icon: "",
      width: "8%",
    },
    {
      headingLabel: "Vendor",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Total Cost",
      icon: "",
      width: "8%",
      dataNode:'totalCost'
    },
    {
      headingLabel: "Extended Cost",
      icon: "",
      width: "9%",
      dataNode:'extendedCost'
    },
    {
      headingLabel: "Show",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Season",
      icon: "",
      width: "6%",
    },
    {
      headingLabel: "Production Company",
      icon: "",
      width: "20%",
      dataNode: "comp_name"
    },
  ],

  dataNodes: [
    "po_number",
    "created_at",
    "vendor_name",
    "total_cost_value",
    "extended_cost_value",
    "show_name",
    "season_name",
    "comp_name",
  ],
  primaryKey: "po_id",
  hyperlinks: ["po_number", "show_name"],
  filtersLanding: true,
};

export const configObjectAllPoUsersFileMaker = {
  iscolumnFilterRequired: true,
  headings: [
    {
      headingLabel: "PO#",
      icon: "",
      width: "7%",
    },
    {
      headingLabel: "Title",
      icon: "",
      width: "22%",
      dataNode:'title'
    },
    {
      headingLabel: "Date",
      icon: "",
      width: "8%",
    },
    {
      headingLabel: "Vendor",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Estimated Cost",
      icon: "",
      width: "10%",
      dataNode:'estimatedCost'
    },
    {
      headingLabel: "Actual Cost",
      icon: "",
      width: "9%",
      dataNode:'actualCost'
    },
    {
      headingLabel: "Show",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Season",
      icon: "",
      width: "6%",
    },
  ],

  dataNodes: [
    "po_number",
    "title",
    "created_at",
    "vendor_name",
    "estimated_cost_value",
    "actual_cost_value",
    "show_name",
    "season_name",
  ],
  primaryKey: "po_id",
  hyperlinks: ["po_number", "show_name"],
  filtersLanding: true,
};

export const configObjectAllPoUsersContentAcquisition = {
  iscolumnFilterRequired: true,
  headings: [
    {
      headingLabel: "PO#",
      icon: "",
      width: "7%",
    },
    {
      headingLabel: "Order Date",
      icon: "",
      width: "8%",
    },
    {
      headingLabel: "Vendor Company",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Vendor Contact",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Description",
      icon: "",
      width: "15%",
    },
    {
      headingLabel: "Total Cost",
      icon: "",
      width: "8%",
    },
    {
      headingLabel: "",
      icon: "",
      width: "1%",
    },
    
  ],

  dataNodes: [
    "po_number",
    "date_ordered",
    "vendor_name",
    "vendor_contact_name",
    "description",
    "purchase_subtotal_3",
    "rush"
  ],
  primaryKey: "po_id",
  hyperlinks: ["po_number"],
  filtersLanding: true,
};

export const allUsersList = [
  {
    id: 1,
    name: "User Name",
    studio: "Studio",
    group: "Group Name",
    department: "Department",
    title: "Title",
    email: "Email",
    phone: "Phone Number",
    status: "Active",
  },
  {
    id: 2,
    name: "User Name",
    studio: "Studio",
    group: "Group Name",
    department: "Department",
    title: "Title",
    email: "Email",
    phone: "Phone Number",
    status: "Active",
  },
  {
    id: 3,
    name: "User Name",
    studio: "Studio",
    group: "Group Name",
    department: "Department",
    title: "Title",
    email: "Email",
    phone: "Phone Number",
    status: "Active",
  },
  {
    id: 4,
    name: "User Name",
    studio: "Studio",
    group: "Group Name",
    department: "Department",
    title: "Title",
    email: "Email",
    phone: "Phone Number",
    status: "Active",
  },
  {
    id: 5,
    name: "User Name",
    studio: "Studio",
    group: "Group Name",
    department: "Department",
    title: "Title",
    email: "Email",
    phone: "Phone Number",
    status: "Active",
  },
  {
    id: 6,
    name: "User Name",
    studio: "Studio",
    group: "Group Name",
    department: "Department",
    title: "Title",
    email: "Email",
    phone: "Phone Number",
    status: "Active",
  },
];

const configObjectAllUsersModal = {
  dataNode: ["user_name"],
  primaryKey: "id",
  actions: ["view", "trash-alt"],
};

export const initialDashboardDropdownDetails = {
  show_id: null,
  season_id: null,
  episode_id: null,
};
export const ActiveOrInActive = [
  {
    value: 0,
    label: "Inactive",
  },
  {
    value: 1,
    label: "Active",
  },
];
export const postFilters = {
  show_name: null,
  po_prefix: null,
  prod_company_name: null,
  vendor_name: null,
  season_name: null,
  gl_number: null,
  total_cost_below: null,
  total_cost_above: null,
  ext_cost_below: null,
  ext_cost_above: null,
  acc_code: null,
  po_date_before: null,
  po_date_after: null,
  sort_by: null,
  sort_order: null,
  page_count: 10,
  page_no: 1,
  showyear_filter: 1,
  po_number: null,
  poet_no:null,
  po_creator:null
};

export const chipFilterObject = {
  show_name: { label: "Show Name", value: "" },
  po_prefix: { label: "PO #", value: "" },
  prod_company_name: { label: "Production Company", value: "" },
  vendor_name: { label: "Vendor Name", value: "" },
  season_name: { label: "Season ", value: "" },
  gl_number: { label: "Episode#", value: "" },
  acc_code: { label: "Detail Number", value: "" },
  total_cost_below: { label: "Cost($) Below", value: "" },
  total_cost_above: { label: "Cost($) Above", value: "" },
  ext_cost_below: { label: "ExtCost($) Below", value: "" },
  ext_cost_above: { label: "ExtCost($) above", value: "" },
  po_date_before: { label: "PO date before", value: "" },
  po_date_after: { label: "PO date after", value: "" },
  po_number: { label: "PO#", value: "" },
  poet_no:{ label: "POET#", value: "" },
  format:{ label: "Version Format", value: "" },
  language:{ label: "Version Language", value: "" },
  order_no:{ label: "Order No", value: "" },
  vendor_invoice:{ label: "Vendor Invoice", value: "" },
  po_creator:{ label: "PO Creator", value: "" },
  cost_center_id:{ label: "Cost Center", value: "" },
  description:{ label: "Description", value: "" },
};
